 
export const RequestAction = Object.freeze({
    Approve: 0,
    Pending: 1,
    Refuse: 2,
});
